import axiosClient from "../../shared/components/requests/axiosCLient";
import { API_URLS } from "../../shared/constants/constants";

export const getPurchasedDetails = (slug) => {
  const url = API_URLS.purchasedDetail(slug);
  return axiosClient.get(url);
};

export const getAccessoriesDetails = (slug) => {
  const url = API_URLS.accessoriesDetail(slug);
  return axiosClient.get(url);
};

export const getConnectedDetails = (slug) => {
  const url = API_URLS.connectedDetail(slug);
  return axiosClient.get(url);
};

export const getFinanceLeasingDetail = (slug) => {
  const url = API_URLS.financeAndLeasingDetail(slug);
  return axiosClient.get(url);
};
